/**
 * Mobile Scroll Fix for Chrome
 * Fixes scrolling issues caused by overflow-hidden and rm-scroll-prevented classes
 */

(function() {
  'use strict';

  // Store original scroll position
  let originalScrollPosition = 0;
  let isScrollLocked = false;

  // Function to check if scrolling is prevented
  function isScrollPrevented() {
    return document.body.classList.contains('overflow-hidden') || 
           document.body.classList.contains('rm-scroll-prevented') ||
           document.body.classList.contains('overflow-hidden-mobile') ||
           document.body.classList.contains('overflow-hidden-tablet');
  }

  // Function to restore scrolling
  function restoreScrolling() {
    if (isScrollPrevented()) {
      // Remove all scroll-preventing classes
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('rm-scroll-prevented');
      document.body.classList.remove('overflow-hidden-mobile');
      document.body.classList.remove('overflow-hidden-tablet');
      document.body.classList.remove('overflow-hidden-desktop');
      
      // Reset body styles
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
      document.body.style.webkitOverflowScrolling = '';
      document.body.style.overscrollBehavior = '';
      
      // Restore scroll position if we have one
      if (originalScrollPosition > 0) {
        window.scrollTo(0, originalScrollPosition);
        originalScrollPosition = 0;
      }
      
      isScrollLocked = false;
    }
  }

  // Function to save scroll position before locking
  function saveScrollPosition() {
    if (!isScrollLocked) {
      originalScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      isScrollLocked = true;
    }
  }

  // Monitor for scroll-preventing classes being added
  function observeBodyChanges() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (isScrollPrevented() && !isScrollLocked) {
            saveScrollPosition();
          }
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Force scroll restoration on various events
  function addScrollRestorationListeners() {
    // Restore scroll on page visibility change
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) {
        setTimeout(restoreScrolling, 100);
      }
    });

    // Restore scroll on window focus
    window.addEventListener('focus', function() {
      setTimeout(restoreScrolling, 100);
    });

    // Restore scroll on touch events (mobile specific)
    document.addEventListener('touchstart', function() {
      if (isScrollPrevented()) {
        setTimeout(restoreScrolling, 50);
      }
    }, { passive: true });

    // Restore scroll on scroll events
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        if (isScrollPrevented()) {
          restoreScrolling();
        }
      }, 100);
    }, { passive: true });

    // Restore scroll on resize
    window.addEventListener('resize', function() {
      setTimeout(restoreScrolling, 100);
    });

    // Restore scroll on orientation change
    window.addEventListener('orientationchange', function() {
      setTimeout(restoreScrolling, 200);
    });
  }

  // Emergency scroll restoration
  function emergencyScrollRestore() {
    // Check if page is scrollable
    const scrollHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight
    );
    
    const viewportHeight = window.innerHeight;
    
    if (scrollHeight > viewportHeight && isScrollPrevented()) {
      restoreScrolling();
    }
  }

  // Initialize the fix
  function init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Check if we're on mobile
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    if (isMobile) {
      
      // Start observing body changes
      observeBodyChanges();
      
      // Add event listeners
      addScrollRestorationListeners();
      
      // Emergency check every 2 seconds
      setInterval(emergencyScrollRestore, 2000);
      
      // Initial check
      setTimeout(emergencyScrollRestore, 1000);
    }
  }

  // Start the fix
  init();

  // Expose functions globally for debugging
  window.mobileScrollFix = {
    restoreScrolling: restoreScrolling,
    isScrollPrevented: isScrollPrevented,
    emergencyScrollRestore: emergencyScrollRestore
  };

})(); 